import { render, staticRenderFns } from "./ServiceTitleList.vue?vue&type=template&id=dceb19a0&scoped=true&lang=pug&"
import script from "./ServiceTitleList.vue?vue&type=script&lang=js&"
export * from "./ServiceTitleList.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTitleList.vue?vue&type=style&index=0&id=dceb19a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dceb19a0",
  null
  
)

export default component.exports